import { fetchEventSource } from '@microsoft/fetch-event-source'

import { getToken } from '@/lib/token'
import type { StreamEvent } from '@/api/types'

export interface StreamHandle {
  abort: () => void
  done: Promise<void>
}

export function streamTurn(
  sessionId: string,
  content: string,
  onEvent: (ev: StreamEvent) => void,
  onError: (err: unknown) => void,
): StreamHandle {
  const token = getToken()
  const ctrl = new AbortController()
  const done = fetchEventSource(`/v1/sessions/${sessionId}/messages`, {
    method: 'POST',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
    },
    body: JSON.stringify({ content }),
    signal: ctrl.signal,
    openWhenHidden: true,
    async onopen(resp) {
      if (!resp.ok) {
        throw new Error(`SSE open failed: ${resp.status}`)
      }
    },
    onmessage(msg) {
      if (!msg.event) return
      try {
        const data = JSON.parse(msg.data)
        onEvent({ event: msg.event, data } as StreamEvent)
      } catch (e) {
        onError(e)
      }
    },
    onerror(err) {
      onError(err)
      throw err // stops auto-retry
    },
  })
  return { abort: () => ctrl.abort(), done }
}
